import {fetchListings} from './utils/listings';

const APIPATH = '/api/listings-search';

export const fetchListingsSearch = (segmentKey) => (dispatch, getState) => {
    const {
        destination: {
            details: {lbsId}
        }
    } = getState();

    const query = {lbsIds: lbsId};

    return fetchListings({
        dispatch,
        getState,
        segmentKey,
        query,
        apiPath: APIPATH
    });
};
